var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[(_vm.importedSvg)?_c('v-img',{attrs:{"src":_vm.path,"max-width":_vm.size,"contain":""}}):_c('cryptoicon',{attrs:{"symbol":_vm.symbol.toLowerCase(),"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }